import { render, staticRenderFns } from "./CompareColumnMain.vue?vue&type=template&id=3aa51bf2&scoped=true&"
import script from "./CompareColumnMain.vue?vue&type=script&lang=ts&"
export * from "./CompareColumnMain.vue?vue&type=script&lang=ts&"
import style0 from "./CompareColumnMain.vue?vue&type=style&index=0&id=3aa51bf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa51bf2",
  null
  
)

export default component.exports